const state = () => ({
  widgets: {},
});

const getters = {
  widgets: (state, getters, rootState, rootGetters) => state.widgets,
};

const mutations = {
  set: function(state, widgets) {
    widgets.forEach(widget => {
      state.widgets[widget.id] = widget;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
